// extracted by mini-css-extract-plugin
export default {"input-container":"support_input-container__Oi4fn","chat-container":"support_chat-container__gfx7L","faq-answer":"support_faq-answer__QcF2h"};